/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createContext, withValue } from 'fierry/react';

import State from 'solis/time/state';

import RefreshEvent from 'solis/time/refresh.event';


const COARSE_DURATION = 15 * 1000;


const Context = createContext();


const Value = withValue(({ state, application }) =>
{
  const time = application.getCurrentTime();

  return time.isRealTime() ? time.getClientDate(state) : time.getClientDate();
});


const Coarse = withValue(({ time }) =>
{
  return Math.floor(time / COARSE_DURATION) * COARSE_DURATION;
});


Context.Coarse = Coarse;


Context.Export = ({ children, ...props }) =>
(
  <State.Export>

    <RefreshEvent />

    <Value.Export {...props} as = {Context} state = {State}>

      <Coarse.Export time = {Context} children = {children} />

    </Value.Export>

  </State.Export>
);


export default Context;
